export const REACT_APP_BUILD_COMMIT_HASH = "123.352"; //process.env.REACT_APP_BUILD_COMMIT_HASH;

export const REACT_APP_BUILD_TIMESTAMP = '12.08.2023'; //process.env.REACT_APP_BUILD_TIMESTAMP;
